import React,{useState,}from 'react'
import { Modal,Form,message, DatePicker,} from 'antd';
import MyEditor from '../../cpn/MyEditor';
import dayjs from 'dayjs';
import { useBnsGuangGaoFaBuHuiBaoUpdateSaveMutation } from '../../store/ReactWebSiteApi';
function PublishReport(props) {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsGuangGaoFaBuHuiBaoUpdateSaveMutation()
    const [info,setInfo] = useState();
    return (
            <>
                <a
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >汇报</a>
                <Modal
                    width={1000}
                    open={open}
                    title='汇报'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "bggfb_huibao_content" : info.bggfb_content,
                                    "bggfb_huibao_ctime" : info.bggfb_huibao_ctime,
                                    "bggfb_id" : props.bggfb_id,                                
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                         <Form.Item name="date"  label='发布日期' required>
                            <DatePicker 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_huibao_ctime:dayjs(e).format('YYYY-MM-DD')}))}}
                            />
                        </Form.Item>
                        <Form.Item name="remark" label='备注' wrapperCol={{span:20}}>
                            <MyEditor 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_huibao_content:e}))}}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
            </>
        )
}

export default PublishReport